module.exports = __webpack_public_path__ + "static/Highspot-f63ee4e38845cb3391179acab303582c.png";